<template>
  <div class="flex min-h-screen flex-col font-Spectral">
    <AtomsJiji :env="env" />
    <OrganismsPagesEnHeader class="l-header" />
    <slot />
    <OrganismsPagesEnGlobalSidebar :on-close="hideGlobalSidebar" :should-show="shouldShowGlobalSidebar" />
    <div class="transition-[margin-right] duration-300 ease-in-out" :class="isSideOpen ? 'mr-[400px]' : 'mr-0'">
      <OrganismsPagesEnFooter />
    </div>
    <!-- ヘッダー、グローバルサイドバーから体験検索モーダルを呼ぶため、EnGlobalにて共通コンポーネントとして扱っている -->
    <SearchExperiencesModal :on-close="close" :should-show-modal="isOpen" />
    <!-- キーワード検索モーダル。開閉状態とモーダル本体は wabunka-src/features/Search 配下で自己完結する -->
    <KeywordSearchModalMount />
  </div>
</template>

<script setup lang="ts">
import SearchExperiencesModal from '@/components/organisms/SearchExperiencesModal/SearchExperiencesModal.vue';
import { useGlobalModal } from '@/composables/ui/useGlobalModal';
import { useGlobalSidebar } from '@/composables/ui/useGlobalSidebar';
import { NavigationFeaturedKey, useFetchNavigationFeatured } from '@/wabunka-src/common/features/Featured/composables/query/useNavigationFeatured';
import { useChatPanel } from '@/wabunka-src/features/Chat/composables/general/useChatPanel';
import KeywordSearchModalMount from '@/wabunka-src/features/Search/components/general/KeywordSearchModalMount.vue';

const { isOpen: shouldShowGlobalSidebar, close: hideGlobalSidebar } = useGlobalSidebar();
const { isSideOpen } = useChatPanel();
const { close, isOpen } = useGlobalModal('searchExperiencesModal');
const runtimeConfig = useRuntimeConfig();
const env = runtimeConfig.public.env;

// ナビゲーション用 Featured データを取得し、子コンポーネント（EnHeader / EnGlobalSidebar）へ provide する
const navigationFeatured = await useFetchNavigationFeatured();
provide(NavigationFeaturedKey, navigationFeatured);
</script>
